import { useState } from "react";
import moment from "moment";
import {
  fechasModalExportacion,
  initValuesFechasModalExportacion,
} from "../models/ModalExportacion/modalexportation.model";
import apiParticipantes from "../api/Participantes/api-participantes";
import fileDownload from "js-file-download";
import apiJurados from "../api/Jurados/api-jurados";
import apiBeps from "../api/Beps/api-beps";
import { openNotification } from "../utils/Notifactions";

export const useModalExportacion = () => {
  const [estadoDatos, setEstadoDatos] = useState("");
  const [fechasExportacion, setFechasExportacion] = useState<fechasModalExportacion>(initValuesFechasModalExportacion);

  const exportarDatos = async (modulo: string, consulta: string) => {

    if (fechasExportacion.fechaDesde > fechasExportacion.fechaHasta) {
      return openNotification({ titulo: "Error", descripcion: "la fecha fin debe ser mayor a la de inico", placement: "bottomRight" });
    }

    if (moment().isBefore(moment(fechasExportacion.fechaHasta).add(1, "hours"))) {
      return openNotification({
        titulo: "Error",
        descripcion: "No puedes escoger fechas mayores a hoy",
        placement: "bottomRight",
      });
    }

    if (modulo === "Participante") {
      let fecha_inicio = moment( fechasExportacion.fechaDesde).format("YYYY-MM-DD");
      let fecha_fin = moment(  fechasExportacion.fechaHasta).format("YYYY-MM-DD");
      if (consulta === "1") {
        let postulaciones = await apiParticipantes.generarReportePostulaciones(estadoDatos, fecha_inicio, fecha_fin);
        if(postulaciones!=null){
          fileDownload(postulaciones, 'reporte.xlsx');
        }
      }
    }
    if (modulo === "Jurados") {
      if (consulta === "1") {
        let jurados = await apiJurados.obtenerProyectosJuradosCriteriosReporte()
        fileDownload(jurados.fileURL, 'reporte.xlsx');
      }
    }
    if (modulo === "Beps") {
      let fecha_inicio = moment( fechasExportacion.fechaDesde).format("YYYY-MM-DD");
      let fecha_fin = moment(  fechasExportacion.fechaHasta).format("YYYY-MM-DD");

      if (consulta === "1") {
        let beps = await apiBeps.gernerarReporte(estadoDatos, fecha_inicio, fecha_fin);
        console.log("Beps: ", beps);
        
        fileDownload(beps, 'reporte.xlsx');
      }
    }
    if(modulo === "Postulaciones"){
      if (consulta === "1") {
        let fecha_inicio = moment( fechasExportacion.fechaDesde ).format("YYYY-MM-DD");
        let fecha_fin = moment( fechasExportacion.fechaHasta ).format("YYYY-MM-DD");
        let postulaciones = await apiParticipantes.generarReporteSeguimientoPostulaciones(estadoDatos, fecha_inicio, fecha_fin )     
        fileDownload(postulaciones, 'reporte.xlsx');
      }
    }
  };

  return {
    fechasExportacion,
    setFechasExportacion,
    estadoDatos,
    setEstadoDatos,
    exportarDatos,
  };
};
